import { HttpHandler } from 'msw'

import { door } from './door'

export const lockers: HttpHandler[] = [...door]
